import {determineMethodType} from "../../utils/helper-functions/determine-method-type";
import {filterObject} from "../../utils/helper-functions/filter-object";
import { isTrueValue } from "../../utils/helper-functions/is-true-value";
import { sendOpenSearchLogs } from "utils/helper-functions/send-open-search-logs.ts";
import {localAdditionalFieldsTypes} from "../../variables/additional-fields-data";

const analyzeAdditionalFields = (additional_fields) => {
    let visibleFields = 0;
    let notRequiredFields = [];
    let isDynamicFields = false;
    if (!additional_fields) additional_fields = [];

    additional_fields.map(({name, type, required: req, data}) => {
        if (["text", "password", "select", "dynamic", ...localAdditionalFieldsTypes].includes(type)) {
            if (req === 0) notRequiredFields = [...notRequiredFields, name]
            visibleFields++;
        }
        if (type === "html") {
            notRequiredFields = [...notRequiredFields, name]
            if (data) visibleFields++
        }
        if (type === "dynamic") {
            isDynamicFields = true
        }
    });
    return {visibleFields, notRequiredFields, isDynamicFields}
}

const analyzeManualBankWire = (additional_fields = [], currency_list={}, base_currency='', base_amount= '') => {
    let baseInList = false;
    let hasJson = false;
    let manualWireCurrencyList = {};
    let manualWireFieldName = '';
    let manualWireResultMarkdown = '';

    if(!additional_fields || additional_fields?.length === 0) {
        const errorText = "type 'manual_bank_wire' must have an additional_field";

        console.error(errorText)
        return {}
    }

    additional_fields?.forEach( ({type, name, data}) => {
        if(type === 'json') {
            hasJson = true;
            try {
                const jsonData = JSON.parse(data);
                const jsonDataFiltered = filterObject({obj: jsonData, objName: `${name} additional field`});
                if(Object.keys(jsonDataFiltered || {})?.length > 0) {
                    if(base_amount) {
                        const amount = Number(base_amount);
                        Object.entries(jsonDataFiltered).forEach(([key, val]) => {
                          const rate = currency_list?.[key];
                          if (!rate) return;
                      
                          const min = Number(rate.min_amount);
                          const max = Number(rate.max_amount);
                      
                          const minOk = Number.isFinite(min) ? amount >= min : true;
                          const maxOk = Number.isFinite(max) ? amount <= max : true;
                      
                          if (minOk && maxOk) {
                            manualWireCurrencyList[key] = val;
                          }
                        });
                    } else {
                        manualWireCurrencyList = jsonDataFiltered;
                    }
                    manualWireFieldName = name;
                    baseInList = !!jsonDataFiltered?.[base_currency]
                } else {
                    const errorText = `${name} additional field json not valid or empty`;

                    console.error(errorText);
                    return {}
                }
            } catch(error) {
                const errorText = `${name} additional field json not provided or not valid. Details: ${error}`;

                sendOpenSearchLogs({
                    event_group: "cashier_analyze_manual_bank_wire",
                    error_data: {
                        error: {
                            message: errorText,
                            stack: error
                        }
                    }
                });

                console.error(errorText);
                return {}
            }
        }

        if(type === 'html') {
            manualWireResultMarkdown = data;
        }
    });

    if(!hasJson) {
        const errorText = "type 'manual_bank_wire' must have an additional_field with type 'json'";

        console.error(errorText)
        return {}
    }

    return {manualWireCurrencyList, manualWireFieldName, baseInList, manualWireResultMarkdown}
}

const analyzeCurrentGateway = (profileInfo, payload, layout) => {
    let {additional_fields, payment_information = {}, promocodeLimits } = payload;
    const {currency_list = {}} = payment_information;
    const {base_currency, base_amount, transaction_type, intent, available_currencies} = profileInfo;
    const baseCurrencyInfo = {
        ...(payment_information?.hasOwnProperty('base_currency') && {currency: payment_information?.base_currency}),
        ...(payment_information?.hasOwnProperty('min_amount') && {min_amount: payment_information?.min_amount}),
        ...(payment_information?.hasOwnProperty('max_amount') && {max_amount: payment_information?.max_amount}),
        ...(payment_information?.hasOwnProperty('crypto') && {crypto: payment_information?.crypto}),
    }
    const isAmountFirst = layout === 'amount-first';
    const array_currency = Object.keys(currency_list);
    const currencyLength = array_currency.length;
    const cryptoList = array_currency.filter((el) => {
        if (isAmountFirst && available_currencies?.currencies) {
            const currencyDetail = available_currencies.currencies.find(c => c.code === el);
            if (currencyDetail) {
                return isTrueValue(currencyDetail.crypto);
            }
        }
        return isTrueValue(currency_list[el]?.crypto);
    });
    const method = determineMethodType(payload);

    return {
        ...(promocodeLimits && {
            promocodeLimits: promocodeLimits,
        }),
        baseInList: !!currency_list?.[base_currency],
        is_auth: method === 'card-method' && transaction_type === "pay-in" && intent === "authorization" && String(base_amount) === "0",
        method, currency_list, currencyLength, cryptoList, baseCurrencyInfo,
        ...analyzeAdditionalFields(additional_fields),
        ...(method === 'mbw-method' && analyzeManualBankWire(additional_fields, currency_list, base_currency, base_amount))
    }
}

export const createGatewayInfo = (state, action) => {
    if (state === undefined) {
        return {
            baseInList: null,
            method: null,
            currency_list: {},
            cryptoList: [],
            currencyLength: null,
            wasteLength: null,
            visibleFields: null,
            notRequiredFields: []
        }
    }
    const layout = state?.initTheme?.theme_editor_settings?.customization_settings?.layout;
    switch (action.type) {
        case  'CREATE_CURRENT_GATEWAY':
            return analyzeCurrentGateway(state.profileInfo, action.payload, layout);
        case  'CREATE_CURRENT_GATEWAY_FROM_AMOUNT_PAGE':
            return analyzeCurrentGateway(state.profileInfo, action.payload, layout);
        default:
            return state.gatewayInfo;
    }
}
